import { render } from "./Outreach.vue?vue&type=template&id=508e3f99&scoped=true"
const script = {}

import "./Outreach.vue?vue&type=style&index=0&id=508e3f99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508e3f99"]])

export default __exports__